import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const Name = styled(Typography)`
  padding-right: 48px;
`

Name.displayName = 'Name'

export default Name
